'use strict';
angular.module('schoolLinqApp').directive('serviceTypeSetup', serviceTypeSetupController);

function serviceTypeSetupController() {
	var controller = [
		'$scope',
		'$q',
		'$uibModal',
		'authService',
		'employeeServiceTypeService',
		function (scope, $q, $uibModal, authService, employeeServiceTypeService) {
			scope.loadServiceTypes = function () {
				scope.dirty = false;
				scope.errors = [];

				(scope.isGA = authService.authentication.isGA),
					(scope.serviceTypes = {
						list: [],
						listBackup: [],
						sortableOptions: {
							cursor: 'move',
							delay: 200,
							forcePlaceholderSize: true,
							opacity: 0.8,
							placeholder: 'ui-sortable-placeholder',
							revert: true,
							stop: function (event, ui) {
								scope.reprioritizeServiceTypes();
							},
						},
					});

				employeeServiceTypeService.getServiceTypes().then(finishedGettingServiceTypes);

				function finishedGettingServiceTypes(response) {
					if (response.data.isValid) {
						scope.serviceTypes.list = response.data.serviceTypes;
						angular.forEach(scope.serviceTypes.list, function (serviceType) {
							serviceType.isDirty = false;
							serviceType.isDeleted = false;
						});

						scope.serviceTypes.listBackup = angular.copy(scope.serviceTypes.list);
					} else {
						if (Array.isArray(response.data.errors)) {
							angular.forEach(response.data.errors, function (err) {
								scope.errors.push(err);
							});
						} else {
							scope.errors.push(response.data.errors);
						}
					}

					if (scope.mustReload === true) {
						scope.mustReload = false;
						scope.afterSave();
					}
				}
			};

			scope.reprioritizeServiceTypes = function () {
				var priority = 0;
				_.forEach(_.where(scope.serviceTypes.list, { isDeleted: false }), function (serviceType) {
					priority++;
					if (serviceType.Priority !== priority) {
						serviceType.Priority = priority;
						serviceType.isDirty = true;
					}
				});
			};

			scope.addServiceType = function () {
				scope.reprioritizeServiceTypes();

				scope.serviceTypes.list.push({
					Id: 0,
					BLC: null,
					Name: null,
					Description: null,
					UseForLeaveAccrual: false,
					Priority: scope.serviceTypes.list.length + 1,
					isDirty: true,
					isDeleted: false,
					CanDelete: true,
				});
			};

			scope.deleteServiceType = function (serviceType) {
				if (serviceType.Id === 0) {
					var index = scope.serviceTypes.list.indexOf(serviceType);
					if (index > -1) {
						scope.serviceTypes.list.splice(index, 1);
					}
				} else {
					serviceType.isDeleted = true;
					serviceType.isDirty = true;
				}

				scope.reprioritizeServiceTypes();
			};

			scope.isDirty = function () {
				if (_.isUndefined(scope.serviceTypes)) scope.dirty = false;
				else
					scope.dirty = _.some(scope.serviceTypes.list, function (serviceType) {
						return serviceType.isDirty;
					});

				return scope.dirty;
			};

			scope.save = function () {
				scope.serviceTypeForm.$setSubmitted();
				if (!scope.serviceTypeForm.$valid) return false;

				scope.errors = [];
				var promises = [];

				_.forEach(scope.serviceTypes.list, function (serviceType) {
					if (serviceType.isDeleted === true) {
						promises.push(
							employeeServiceTypeService.deleteServiceType(serviceType.Id).then(_.partial(finishedDeletingItem, serviceType))
						);
					} else if (serviceType.isDirty === true) {
						promises.push(employeeServiceTypeService.addupdateServiceType(serviceType).then(_.partial(finishedSavingItem, serviceType)));
					}
				});

				if (promises.length) {
					$q.all(promises).then(function () {
						if (scope.errors.length === 0) {
							scope.serviceTypes.listBackup = angular.copy(scope.serviceTypes.list);
							scope.afterSave();
						} else scope.mustReload = true;
					});
				}

				function finishedDeletingItem(serviceType, response) {
					if (response.data.isValid && response.data.result === true) {
						var index = scope.serviceTypes.list.indexOf(serviceType);
						if (index > -1) {
							scope.serviceTypes.list.splice(index, 1);
						}
					} else {
						if (Array.isArray(response.data.errors)) {
							angular.forEach(response.data.errors, function (err) {
								scope.errors.push(serviceType.Name + ' error: ' + err);
							});
						} else {
							scope.errors.push(response.data.errors);
						}
					}
				}

				function finishedSavingItem(serviceType, response) {
					if (response.data.isValid) {
						serviceType.Id = response.data.id;
						serviceType.isDirty = false;
					} else {
						if (Array.isArray(response.data.errors)) {
							angular.forEach(response.data.errors, function (err) {
								scope.errors.push(serviceType.Name + ' error: ' + err);
							});
						} else {
							scope.errors.push(response.data.errors);
						}
					}
				}
			};

			scope.cancelChanges = function () {
				scope.serviceTypes.list = angular.copy(scope.serviceTypes.listBackup);
				scope.errors = [];
				scope.afterCancel();
			};

			scope.useForLeaveAccrualChanged = function (serviceType) {
				_.each(scope.serviceTypes.list, function (item) {
					if (item.Priority !== serviceType.Priority) {
						if (item.UseForLeaveAccrual === true) item.isDirty = true;
						item.UseForLeaveAccrual = false;
					}
				});
			};
		},
	];

	return {
		restrict: 'E',
		scope: {
			okToLoad: '=', // flag to enable/disable loading of data
			readonly: '=', // flag indicating read-only status
			dirty: '=', // let's consumer know if the directive has unsaved changes
			doCancel: '=', // allows consumer to trigger the directive's cancelChanges() function
			afterSave: '&', // reference to function to run after successful save operation
			afterCancel: '&', // reference to function to run after cancel operation
		},
		replace: true,
		template: require('@ajs/templates/serviceTypeSetup.html'),
		controller: controller,
		link: function (scope, element, attrs) {
			scope.$watch('okToLoad', function (value) {
				if (value === true) scope.loadServiceTypes();
			});

			scope.$watch('doCancel', function (value) {
				if (value === true) {
					scope.doCancel = false;
					scope.cancelChanges();
				}
			});

			if (scope.readonly === true) {
				scope.sortableOptions = {
					disabled: true,
				};
			} else {
				scope.sortableOptions = {
					cursor: 'move',
					delay: 200,
					forcePlaceholderSize: true,
					opacity: 0.8,
					placeholder: 'ui-sortable-placeholder',
					revert: true,
					stop: function (event, ui) {
						scope.reprioritizeServiceTypes();
					},
				};
			}
		},
	};
}

angular.module('schoolLinqApp').directive('validateDuplicateTypeName', function () {
	return {
		require: 'ngModel',
		link: function (scope, elem, attr, ngModel) {
			ngModel.$parsers.unshift(function (value) {
				var Priority = parseInt(attr.validateDuplicateTypeName);

				var numberOfMatches = scope.serviceTypes.list.filter(function (row) {
					let rowName = _.isNull(row.Name) === true || _.isUndefined(row.Name) === true ? '' : row.Name;
					return rowName.toLowerCase().trim() === value.toLowerCase().trim() && row.Priority !== Priority;
				}).length;

				var isValid;
				if (numberOfMatches > 0) {
					isValid = false;
				} else {
					isValid = true;
				}

				ngModel.$setValidity('validateDuplicateTypeName', isValid);
				return value;
			});
		},
	};
});
